export const REQUEST_BEGIN = 'REQUEST_BEGIN';
export const REQUEST_FAILURE = 'REQUEST_FAILURE';
export const GET_USER_DATA_SUCCESS = 'GET_USER_DATA_SUCCESS';
export const RESET_USER_PROFILE = 'RESET_USER_PROFILE';
export const SET_USER_DATA_SUCCESS = 'SET_USER_DATA_SUCCESS';